import { persons as kycAcceptance } from '#proto/index.qonto.kycb.acceptance';
import type { firstparty as kycVerification } from '#proto/index.qonto.kycb.api.kyc_verification';

export type KycResponse = kycAcceptance.firstparty.v1.ApiGetPersonAcceptanceResponse;
export type FourthlineProviderDetails = kycAcceptance.firstparty.v1.ApiFourthlineProviderDetails;
export type IdnowProviderDetails = kycAcceptance.firstparty.v1.ApiIdnowProviderDetails;
export const KycCurrentStatus = kycAcceptance.firstparty.v1.ApiKycCurrentStatus;
export const KycProcessType = kycAcceptance.firstparty.v1.ApiProcessType;
export const KycProcessStatus = kycAcceptance.firstparty.v1.ApiProcessStatus;
export const KycProvider = kycAcceptance.firstparty.v1.ApiProvider;
export const IdnowProviderDetailsStatus = kycAcceptance.firstparty.v1.ApiIdnowProviderDetailsStatus;

export type SendKycSmsResponse = kycVerification.v3.ApiSendKycSmsResponseKyc;
export type SendKycSmsRequest = kycVerification.v3.ApiSendKycSmsRequestKyc;
